/**
 * After Login Routes
 *
 * All child routes are protected by AuthGuard, which checks for a valid session
 * token in sessionStorage and redirects to '/' if absent.
 *
 * BaseRedirect (index route) is intentionally NOT guarded — it performs
 * its own token check and handles the initial redirect logic.
 */
import React from 'react';
import { Route } from 'react-router-dom';
import AuthGuard from '../components/AuthGuard';

// Lazy load after-login components
const AfterLogin = React.lazy(() => import('../after-login/AfterLogin'));
const MyDashboard = React.lazy(() => import('../after-login/my-dashboard/MyDashboard'));
const CreditBalance = React.lazy(() => import('../after-login/credit-balance/CreditBalance'));
const Shop = React.lazy(() => import('../after-login/shop/Shop'));
const Profile = React.lazy(() => import('../after-login/profile/Profile'));
const FAQs = React.lazy(() => import('../after-login/faqs/FAQs'));
const ReferAndEarn = React.lazy(() => import('../after-login/refer-and-earn/ReferAndEarn'));
const MyStatement = React.lazy(() => import('../after-login/my-statement/MyStatement'));
const PaymentHistory = React.lazy(() => import('../after-login/payment-history/PaymentHistory'));
const CreditScore = React.lazy(() => import('../after-login/credit-score/CreditScore'));
const BaseRedirect = React.lazy(() => import('../after-login/base-redirect/BaseRedirect'));

export const AfterLoginRoutes = (
  <Route path="/dashboard" element={<AfterLogin />}>

    <Route path="my-dashboard" element={<AuthGuard><MyDashboard /></AuthGuard>} />
    <Route path="personal-loan" element={<AuthGuard><CreditBalance /></AuthGuard>} />
    <Route path="shop" element={<AuthGuard><Shop /></AuthGuard>} />
    <Route path="profile" element={<AuthGuard><Profile /></AuthGuard>} />
    <Route path="faqs" element={<AuthGuard><FAQs /></AuthGuard>} />
    <Route path="refer-and-earn" element={<AuthGuard><ReferAndEarn /></AuthGuard>} />
    <Route path="my-statement" element={<AuthGuard><MyStatement /></AuthGuard>} />
    <Route path="payment-history" element={<AuthGuard><PaymentHistory /></AuthGuard>} />
    <Route path="credit-balance" element={<AuthGuard><CreditBalance /></AuthGuard>} />
    <Route path="tripmoney/:merchantName" element={<AuthGuard><CreditBalance /></AuthGuard>} />
    <Route path="know-your-credit-score" element={<AuthGuard><CreditScore /></AuthGuard>} />

    {/* BaseRedirect has no AuthGuard — it performs its own token check internally. */}
    <Route index element={<BaseRedirect />} />
  </Route>
);
